import { useContext } from 'react';
import './bottom-cart.css';
import { Link } from 'react-router-dom';
import { cartContext } from '../App';

export default function BottomCart() {

    const { CartItem, extraData } = useContext(cartContext);

    const orderValue = CartItem.reduce((sum, item) => sum + Math.round(item.details.price * (100 - item.details.discount) / 100) * item.qty, 0);
    
    const freeDelShow = orderValue >= extraData.data.minOrderValueFee ? true : false

    return (
        <>
            {
                CartItem.length > 0 ? (
                    <div className='bottom-cart'>
                        {
                            freeDelShow && 
                            <div className='bottom-cart-high'>
                                <p className='bottom-cart-free-delivery-text'>🎉 Woohoo! Free Delivery Unlocked - No Extra Charges! 🚚</p>
                            </div>
                        }
                        <div className='bottom-cart-low'>
                            {
                                CartItem.length > 1 ?
                                    (<p className='items-no-bottom-cart'>{CartItem.length} items &#10242;<span style={{fontFamily:'Arial'}}>&#8377;</span>{ orderValue }</p>) :
                                    (<p className='items-no-bottom-cart'>{CartItem.length} item &#10242;<span style={{fontFamily:'Arial'}}>&#8377;</span>{ orderValue }</p>)
                            }
                            <div className='bottom-cart-link-container'>
                                <Link to='/cart' className='bottom-cart-link'>
                                    View Cart
                                    <img src='shopping-cart.png' alt='cart' className='bottom-cart-icon'/>
                                </Link>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className='bottom-cart' style={{display: 'none'}}>
                        <p className='items-no-bottom-cart'>{CartItem.length} item</p>
                        <div className='bottom-cart-link-container'><Link to='/cart' className='bottom-cart-link'>Cart</Link></div>
                    </div>
                )
            }
        </>
        
    );
}